import React from 'react';
import './FeaturesCard.css'; // Assuming you have a CSS file to style the card
import { useTranslation } from 'react-i18next';

function FeaturesCard(props) {
  const { t } = useTranslation();
  const { title, description, image, model } = props;

  // Ensure model 1 is default by using nullish coalescing
  const imageClassName = `features-card-image features-card-image-model${model ?? 1}`;
  const titleClassName = `features-card-title${model === 2 ? ' features-card-title-model2' : ''}`;

  return (
    <div className="features-card">
      <img src={image} alt={title} className={imageClassName}></img>
      <div className="features-card-content">
        <h3 className={titleClassName}>{t(title)}</h3>
        <p className="features-card-description">{t(description)}</p>
      </div>
    </div>
  );
}

export default FeaturesCard;
